import React from 'react';
import PropTypes from 'prop-types';
import { componentText } from '../utils/i18n_utils';

const PointsAndPurseButton = ({ button }) => {
  if (!button) return null;

  const label = button.shown
    ? componentText('points_and_purse_button.hide', 'Hide points and purse')
    : componentText('points_and_purse_button.show', 'Show points and purse');

  return (
    <a className="lbv2__points-purse-btn" href={button.href}>
      {label}
    </a>
  );
};

PointsAndPurseButton.propTypes = {
  button: PropTypes.shape({
    shown: PropTypes.bool,
    href: PropTypes.string,
  }),
};

export default PointsAndPurseButton;
